import ReactDOM from 'react-dom';
import React from 'react';
import Header from '../components/header-ui';
import theme from '../theme';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {create} from 'jss';
import {StylesProvider, jssPreset} from '@material-ui/styles';

(window as any).HeaderUI = {
    initialize: () => {
        const jss = create({
            plugins: [...jssPreset().plugins],
        });

        ReactDOM.render(
            <StylesProvider jss={jss}>
                <MuiThemeProvider theme={theme}>
                    <Header />
                </MuiThemeProvider>
            </StylesProvider>,
            document.getElementById('base_header')
        );
    },
};
